import { pages } from '../util/global-methods'
import { deployEnv } from '~/config'

const routes = [
  {
    path: 'product/:friendlyPath',
    name: 'city',
    component: pages('city'),
    props: true,
    meta: { store: 'product' },
  },
  {
    path: 'product-preview/:friendlyPath/:productId',
    component: pages('city/product'),
    props: true,
    meta: { store: 'product' },
  },
  {
    path: 'seller/:sellerId',
    component: pages('city/seller'),
    props: true,
    meta: { store: 'product' },
  },
]

if (deployEnv === 'dev' || deployEnv === 'qa') {
  routes.push({
    path: 'product/markup/:friendlyPath/:productId',
    component: pages('city/product/markup'),
    query: { myInquiryKey: 0 },
    props: true,
    meta: { store: 'product' },
  })
}

export default routes
